import { apiClient, type RequestOptions } from '@/services/apiClient';
import type { InfraCommandCenter } from './infra.types';

export const infraApi = {
  getDashboard: (options?: RequestOptions) => apiClient.get<InfraCommandCenter>('/v1/infra/command-center', options),
  runReadiness: (_input: void, options?: RequestOptions) => apiClient.post<InfraCommandCenter['runs'][number]>('/v1/infra/readiness', {}, options),
};
